import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '',
        name: 'def',
        component: ()=>import(/* webpackChunkName: "def" */ '@/views/home/def')
      },
      {
        path: '/category',
        name: 'category',
        component: ()=>import(/* webpackChunkName: "category" */ '@/views/home/category'),
      },
      {
        path: '/echo',
        name: 'echo',
        component: ()=>import(/* webpackChunkName: "echo" */ '@/views/home/echo'),
      },
      {
        path: '/files',
        name: 'files',
        component: ()=>import(/* webpackChunkName: "files" */ '@/views/home/files')
      },
      {
        path: '/my/:uid',
        component: ()=>import(/* webpackChunkName: "my" */ '@/views/home/my'),
        children: [
          {
            path: '',
            name: 'myindex',
            props: true,
            component: ()=>import(/* webpackChunkName: "myindex" */ '@/views/home/my/index'),
            meta: { father: '/my' },
          },
          {
            path: '/myedit',
            name: 'myedit',
            component: ()=>import(/* webpackChunkName: "myedit" */ '@/views/home/my/myedit')
          }
        ]
      },
      {
        path: '/info/:infoid',
        name: 'info',
        props: true,
        component: ()=> import(/* webpackChunName: "info" */ '@/views/home/info')
      },
      {
        path: '/echoInfo/:id',
        name: 'echoInfo',
        props: true,
        component: ()=>import(/* webpachChunkName: "echoInfo" */ '@/views/home/echoInfo')
      },
      {
        path: '/comment',
        name: 'comment',
        component: ()=>import(/* webpackChunkName: "comment" */ '@/views/home/comment')
      }
    ]
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/dist/' : '/',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
